angular.module('aq.filters.time')
.filter('formatDate', function(UserService) {
    return function(input, format, timezone) {
        if (!input) {
            return null;
        }
        var date = moment(input).locale(UserService.locale());
        return timezone ? date.tz(timezone).format(format) : UserService.dateToTimezone(date).format(format);
    }
});